<script lang="ts" module>
	export const symbolId = "ishavskraft-icon-history";
	export const symbol = `
		<symbol id="${symbolId}" viewBox="0 0 45 45">
			<path
				d="M16.875 33.75C12.9375 33.75 9.45313 32.555 6.42188 30.165C3.39063 27.775 1.42188 24.72 0.515625 21C0.390625 20.5312 0.484375 20.1019 0.796875 19.7119C1.10937 19.3219 1.53125 19.095 2.0625 19.0312C2.5625 18.9687 3.01562 19.0625 3.42187 19.3125C3.82812 19.5625 4.10938 19.9375 4.26563 20.4375C5.01563 23.25 6.5625 25.5469 8.90625 27.3281C11.25 29.1094 13.9062 30 16.875 30C20.5313 30 23.6331 28.7269 26.1806 26.1806C28.7281 23.6344 30.0012 20.5325 30 16.875C29.9988 13.2175 28.7256 10.1163 26.1806 7.57125C23.6356 5.02625 20.5337 3.7525 16.875 3.75C14.7188 3.75 12.7031 4.25 10.8281 5.25C8.95312 6.25 7.375 7.625 6.09375 9.375H9.375C9.90625 9.375 10.3519 9.555 10.7119 9.915C11.0719 10.275 11.2512 10.72 11.25 11.25C11.2488 11.78 11.0687 12.2256 10.71 12.5869C10.3512 12.9481 9.90625 13.1275 9.375 13.125H1.875C1.34375 13.125 0.89875 12.945 0.54 12.585C0.18125 12.225 0.00125 11.78 0 11.25V3.75C0 3.21875 0.18 2.77375 0.54 2.415C0.9 2.05625 1.345 1.87625 1.875 1.875C2.405 1.87375 2.85062 2.05375 3.21187 2.415C3.57312 2.77625 3.7525 3.22125 3.75 3.75V6.28125C5.34375 4.28125 7.28937 2.73437 9.58687 1.64062C11.8844 0.546875 14.3137 0 16.875 0C19.2188 0 21.4144 0.445625 23.4619 1.33688C25.5094 2.22813 27.2906 3.43063 28.8056 4.94438C30.3206 6.45813 31.5238 8.23938 32.415 10.2881C33.3063 12.3369 33.7512 14.5325 33.75 16.875C33.7488 19.2175 33.3038 21.4131 32.415 23.4619C31.5263 25.5106 30.3231 27.2919 28.8056 28.8056C27.2881 30.3194 25.5069 31.5225 23.4619 32.415C21.4169 33.3075 19.2213 33.7525 16.875 33.75ZM18.75 16.125L23.4375 20.8125C23.7813 21.1563 23.9531 21.5938 23.9531 22.125C23.9531 22.6563 23.7813 23.0937 23.4375 23.4375C23.0937 23.7813 22.6563 23.9531 22.125 23.9531C21.5938 23.9531 21.1563 23.7813 20.8125 23.4375L15.5625 18.1875C15.375 18 15.2344 17.7894 15.1406 17.5556C15.0469 17.3219 15 17.0794 15 16.8281V9.375C15 8.84375 15.18 8.39875 15.54 8.04C15.9 7.68125 16.345 7.50125 16.875 7.5C17.405 7.49875 17.8506 7.67875 18.2119 8.04C18.5731 8.40125 18.7525 8.84625 18.75 9.375V16.125Z"
				fill="currentColor"
			/>
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		class: classes = null,
		ariaHidden = true,
	}: {
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

<svg
	aria-hidden={ariaHidden}
	width="24"
	height="24"
	viewBox="0 0 45 45"
	xmlns="http://www.w3.org/2000/svg"
	class={classes}
	fill="currentColor"
>
	<use href="#{symbolId}" />
</svg>
